import { QRCodeSVG } from "qrcode.react";

import { Button } from "../../components/Button";
import { QR_PREFIX } from "./constants";

export function BonusAdminDebitPage({
  deductAmount,
  onDeductAmountChange,
  deductPreview,
  generating,
  error,
  generatedToken,
  generatedBonusAmount,
  onGenerateDebit,
}) {
  return (
    <div className="bonusGeneratePage">
      <div className="homeSurface bonusGeneratePage__surface">
        <div className="bonusGeneratePage__body">
          <label className="field">
            Списать бонусов
            <input
              type="number"
              min={1}
              inputMode="numeric"
              placeholder="Например, 100"
              value={deductAmount}
              onChange={(e) => onDeductAmountChange(e.target.value)}
            />
          </label>
          {deductPreview != null ? (
            <div
              className="bonusGeneratePage__previewCard bonusGeneratePage__previewCard--debit"
              aria-live="polite"
            >
              <span className="bonusGeneratePage__previewLabel">Списание при сканировании</span>
              <span className="bonusGeneratePage__previewValue bonusGeneratePage__previewValue--debit">
                −{deductPreview}{" "}
                <span className="bonusGeneratePage__previewUnit">бонусов</span>
              </span>
              <span className="bonusGeneratePage__previewHint">Не больше текущего баланса гостя</span>
            </div>
          ) : null}
          <Button variant="accent" onClick={onGenerateDebit} disabled={generating}>
            {generating ? "Генерация..." : "Создать QR"}
          </Button>
          {error ? <p className="errorMessage bonusGeneratePage__error">{error}</p> : null}
        </div>
      </div>

      {generatedToken ? (
        <div className="homeSurface bonusGeneratePage__surface bonusGeneratePage__surface--qr">
          <div className="bonusGeneratePage__qrBlock">
            <div className="bonusGeneratePage__qrFrame">
              <QRCodeSVG
                value={`${QR_PREFIX}${generatedToken}`}
                size={216}
                bgColor="#ffffff"
                fgColor="#1d1d1b"
                level="M"
              />
            </div>
            <p className="bonusGeneratePage__qrHint">
              {generatedBonusAmount != null ? (
                <>
                  С баланса гостя спишется{" "}
                  <strong className="bonusGeneratePage__qrDebitStrong">−{generatedBonusAmount}</strong>{" "}
                  бонусов.{" "}
                </>
              ) : null}
              Пусть гость отсканирует QR в приложении Telegram.
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
}
